import { render, staticRenderFns } from "./ItemListDetectionItemLayout.vue?vue&type=template&id=af79f44e&scoped=true"
import script from "./ItemListDetectionItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemListDetectionItemLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af79f44e",
  null
  
)

export default component.exports